import { Anchor, Box, Card, Paragraph, TextButton } from '@zillow/constellation-10';
import { useCallback } from 'react';
import { useMediaQuery } from '@zg-rentals/react-hooks';
import numberUtils from 'app/shared/utils/numberUtils';
import { Area, ComposedChart, Line, XAxis, YAxis } from 'recharts';

import type { Market } from 'app/shared/types/Market';

const MarketPreview = (props: Market & { emitAnalyticsEvent?: () => void }) => {
  const { name, medianRent, prices, url, emitAnalyticsEvent } = props;
  const isSmallScreen = useMediaQuery('(max-width: 769px)');
  const exploreMarket = useCallback(() => {
    if (emitAnalyticsEvent) {
      emitAnalyticsEvent();
    }
  }, [emitAnalyticsEvent]);
  return prices ? (
    <Anchor href={url} onClick={exploreMarket} className="group" css={{ textDecoration: 'none' }}>
      <Card
        tone="neutral"
        css={{
          height: { base: '200px', _smallScreen: '180px' },
          padding: { base: '400', _smallScreen: '200' },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'baseline',
        }}
        key={name}
      >
        <Paragraph textStyle="body-sm-bold">{name}</Paragraph>
        <Paragraph textStyle="body-sm">{numberUtils.asCurrency(medianRent)}</Paragraph>
        <Box css={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '1' }}>
          <ComposedChart
            width={isSmallScreen ? 120 : 140}
            height={60}
            data={prices.map((price) => {
              return { price };
            })}
            style={{ cursor: 'pointer' }}
          >
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#50E3FF" stopOpacity={0.25} />
                <stop offset="100%" stopColor="#FFBFAD" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey="time" tick={false} hide={true} />
            <YAxis tick={false} hide={true} domain={['auto', 'auto']} />
            <Line
              type="monotone"
              strokeLinecap="round"
              strokeWidth={2}
              dataKey="price"
              stroke="#50E3FF"
              dot={false}
              legendType="none"
            />
            <Area type="monotone" dataKey="price" strokeWidth={2} fillOpacity={1} fill="url(#colorUv)" />
          </ComposedChart>
        </Box>
        <TextButton.Label textStyle="body-sm">Explore market</TextButton.Label>
      </Card>
    </Anchor>
  ) : null;
};

export default MarketPreview;
